import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.css']
})
export class StarRatingComponent implements OnInit {

  @Input() starRating: any;
  @Input() starSize: any = '1.6rem';
  @Input() starFloat: any;
  @Input() starColor: any = '#ff2400';

  constructor() { }

  ngOnInit(): void {
  }

}
